/*
 * True only when the article's owning publication is known AND is not part
 * of the current publication's hosted family. Fails open (false) when either
 * name is missing, preserving current render behavior for payloads that
 * omit the field. When allowedPublications is empty, the family is just the
 * current publication itself.
 */
export function isForeignArticle (articlePublicationName?: string, currentName?: string, allowedPublications?: string[]): boolean {
  if (!articlePublicationName || !currentName) {
    return false;
  }
  const family = (allowedPublications?.length ? allowedPublications : [currentName]).map(name => name.toLowerCase());
  return !family.includes(articlePublicationName.toLowerCase());
}
